import { showModal } from 'modal.react.js';

import area from 'components/shared/GlobalModalArea/area';
import Modal from 'components/shared/GlobalModalArea/Modal';

import Button from '../Button';
import Icon from '../Icon';
import DateOrDay from '../Icon/icons/DateOrDay';
import Text from '../Typography/Text';
import styles from './index.module.css';
import { SyncToCalendarForm } from './SyncToCalendarForm';

export const SyncCalendar = () => {
  const openSyncModal = () => {
    showModal(area, (callback) => (
      <Modal
        noPadding
        size="md"
        isOpen
        toClose={(event) => {
          event.stopPropagation();
          callback(event);
        }}
        stopMouseDownPropagation
      >
        <SyncToCalendarForm />
      </Modal>
    ));
  };

  return (
    <div className={styles.syncWrapper}>
      <Button className={styles.syncButton} onClick={openSyncModal} size="small" type="default" shape="ellipse">
        <Icon component={DateOrDay} className={styles.syncCalendarIcon} />
        <Text className={styles.buttonText}>Sync to Calendar</Text>
      </Button>
    </div>
  );
};
